import React from 'react';
import PropTypes from 'prop-types';

import FlatButtonFilters from 'components/consumer/FlatButtonFilters';
import IconSearch from 'components/icons/IconSearch';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import LivestreamVideoThumbnail from '../LivestreamVideoThumbnail';

const LivestreamLatestVideosUI = ({
  searchText,
  setSearchText,
  selectedFilter,
  setSelectedFilter,
  videoCategories = [],
  videos = [],
}) => (
  <div className="mt-10 lg:mt-24">
    <h3 className="text-3xl font-bold text-gray m-0">Latest videos</h3>
    <div className="flex flex-col mx-0 my-4 lg:items-end lg:flex-row lg:justify-between lg:mt-0 lg:mx-0 lg:mb-9">
      <div className="mt-4 mx-0 mb-0 lg:m-0">
        <FlatButtonFilters
          items={videoCategories}
          selectedItem={selectedFilter}
          setSelectedItem={setSelectedFilter}
          showMarginBottom={false}
          scrollOnMobile
        />
      </div>

      <div className="md:w-[calc((100%_-_1.75rem)_/2)] lg:w-[calc((100%_-_3.5rem)_/3)]">
        <LabeledTextInput
          className="mt-6 mx-0 mb-4 lg:m-0"
          label="Search videos"
          value={searchText}
          onChange={event => {
            setSearchText(event.target.value);
          }}
          action={<IconSearch />}
          actionAlignment="left"
          actionStretchHeight
          variant="livestream-search"
        />
      </div>
    </div>

    <div className="grid gap-7 pb-8 md:grid-cols-[1fr_1fr] lg:grid-cols-[1fr_1fr_1fr]">
      {videos.map(
        ({
          slug,
          category,
          image,
          isNowPlaying,
          isRecordedLive,
          isSelected,
          title,
          videoLength,
          videoType,
          videoId,
        }) => (
          <LivestreamVideoThumbnail
            slug={slug}
            category={category}
            image={image}
            isNowPlaying={isNowPlaying}
            isRecordedLive={isRecordedLive}
            isSelected={isSelected}
            title={title}
            videoLength={videoLength}
            videoType={videoType}
            videoId={videoId}
          />
        )
      )}
    </div>
  </div>
);

LivestreamLatestVideosUI.propTypes = {
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
  selectedFilter: PropTypes.string,
  setSelectedFilter: PropTypes.func,
  videoCategories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
    })
  ),
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      image: PropTypes.string,
      isRecordedLive: PropTypes.bool,
      title: PropTypes.string,
      videoId: PropTypes.string,
      videoLength: PropTypes.string,
    })
  ),
};

export default LivestreamLatestVideosUI;
